// For some text areas that aren't within forms (i.e. editing comments, step
// edit) to get the command+enter shortcut, the 'data-submit-button' attribute
// must be added to a parent with the value of the class the submit button has.

window.addEventListener('keydown', ev => {
   // Submits the current form on command+enter or ctrl+enter
   if (ev.key === 'Enter' && (ev.metaKey || ev.ctrlKey)) {
      if (!ev.target.matches("textarea, input[type='text']")) {
         return;
      }

      let form = ev.target.closest('form');
      if (form) {
         form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      } else {
         // Field isn't within a form, find the submit button
         let formParent = ev.target.closest('[data-submit-button]');
         if (!formParent) {
            return;
         }

         let buttonName = formParent.dataset.submitButton;
         let submitButton = formParent.querySelector(':scope > .' + buttonName);

         submitButton.click();
      }
   }
});
